import { Plus, Trash2, ArrowUp, ArrowDown } from "lucide-react";
import { field, Label } from "../formBits";

const uid = () => Math.random().toString(36).slice(2, 12);

export const Toggle = ({ testid, checked, onChange, children }) => (
  <label className="flex items-center gap-3 cursor-pointer">
    <input data-testid={testid} type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} className="w-4 h-4 accent-[#F5A524]" />
    <span className="font-mono text-xs tracking-[0.2em] text-zinc-300">{children}</span>
  </label>
);

export const Text = ({ label, testid, value, onChange, placeholder, rows }) => (
  <label className="block min-w-0"><Label>{label}</Label>
    {rows
      ? <textarea data-testid={testid} rows={rows} value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className={field} />
      : <input data-testid={testid} value={value ?? ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className={field} />}
  </label>
);

const Ctl = ({ testid, label, onClick, disabled, danger, children }) => (
  <button type="button" data-testid={testid} aria-label={label} title={label} onClick={onClick} disabled={disabled}
    className={`p-2 border transition-colors disabled:opacity-30 ${danger ? "border-[#FF2A55]/40 text-[#FF2A55] hover:bg-[#FF2A55] hover:text-black" : "border-[#F5A524]/30 text-zinc-300 hover:text-[#F5A524]"}`}>{children}</button>
);

const move = (arr, i, d) => {
  const j = i + d;
  if (j < 0 || j >= arr.length) return arr;
  const out = [...arr];
  [out[i], out[j]] = [out[j], out[i]];
  return out;
};

// Reorderable list of cards. `render(item, patch, i)` draws the fields for one item.
export const ListEditor = ({ items, onChange, blank, render, prefix, addLabel }) => (
  <div className="space-y-3">
    {items.map((it, i) => (
      <div key={it.id} data-testid={`${prefix}-row-${i}`} className="bg-[#0B0C10] border border-[#F5A524]/15 p-3 sm:p-4 space-y-3">
        <div className="flex items-center justify-between gap-2">
          <span className="font-mono text-[11px] tracking-[0.25em] text-[#F5A524]">#{String(i + 1).padStart(2, "0")}</span>
          <div className="flex gap-1">
            <Ctl testid={`${prefix}-up-${i}`} label="Move up" onClick={() => onChange(move(items, i, -1))} disabled={i === 0}><ArrowUp size={13} /></Ctl>
            <Ctl testid={`${prefix}-down-${i}`} label="Move down" onClick={() => onChange(move(items, i, 1))} disabled={i === items.length - 1}><ArrowDown size={13} /></Ctl>
            <Ctl testid={`${prefix}-remove-${i}`} label="Remove" danger onClick={() => onChange(items.filter((x) => x.id !== it.id))}><Trash2 size={13} /></Ctl>
          </div>
        </div>
        {render(it, (p) => onChange(items.map((x) => (x.id === it.id ? { ...x, ...p } : x))), i)}
      </div>
    ))}
    <button type="button" data-testid={`${prefix}-add-btn`} onClick={() => onChange([...items, { ...blank, id: uid() }])}
      className="flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] text-[#F5A524] border border-dashed border-[#F5A524]/40 px-4 py-2.5 hover:bg-[#F5A524]/10">
      <Plus size={14} /> {addLabel}
    </button>
  </div>
);
